/* eslint-disable import/prefer-default-export */

import styled from 'styled-components';
import colors from 'styles/colors';
import { fontWeight } from 'styles/common';

export const StyledModalInput = styled.div<{ error?: string; $labelPresent: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ error }) => (error ? '-18px' : '0px')};
  color: ${({ error }) => (error ? colors.inputError : colors.black)} !important;

  label {
    font-size: 12px;
    font-weight: ${fontWeight.semibold};
    margin-bottom: 3px;
  }

  input {
    font-weight: 600;
    font-weight: ${fontWeight.semibold};
    color: ${({ error }) => (error ? colors.inputError : colors.black)} !important;
    background-color: ${({ error }) => (error ? colors.inputErrorBackground : '')} !important;
    border-color: ${colors.fleetOffGray} !important;
    border-left-color: ${({ $labelPresent }) => ($labelPresent ? 'transparent !important' : 'inherit')};
  }

  input:focus {
    border-color: ${colors.fleetBlue} !important;
  }
`;

export const StyledSearchableCard = styled.div`
  .ui.card {
    box-shadow: 0 0 0 1px ${colors.fleetOffGray}, 0 2px 6px 0 rgba(0, 0, 0, 0.08);
  }

  .searchable-card-wrapper {
    margin: 0 !important;
  }

  .searchable-card-header-wrapper {
    height: 100%;
    padding: 0;
    margin: 0 !important;
  }

  .searchable-card-search-wrapper > div {
    margin: 16px 24px;
  }

  .searchable-card-search-wrapper > div > div {
    border-color: ${colors.fleetOffGray} !important;
  }

  .beem-react-select__control {
    border-color: ${colors.fleetOffGray} !important;
  }

  .beem-react-select__control--is-focused {
    border-color: ${colors.fleetBlue} !important;
  }

  .ui.header {
    margin: 0 0 4px 0 !important;
    padding: 4px !important;
    font-size: 14px;
    font-weight: 600;
  }

  .ui.grid > .row.one {
    margin: 0 !important;
    padding: 0 10px !important;

    & > h5 {
      padding: 0 !important;
    }
  }

  .searchableCard__searchContent___s5KTi {
    margin-top: 0 !important;
    min-height: 164px;
  }

  .ui.basic.label.label {
    border: 1px solid ${colors.fleetOffGray} !important;
  }
`;

export const StyledClearButton = styled.button`
  color: ${colors.fleetBlue};
  font-weight: 600;
  margin-left: auto;
  border: none;
  padding: 0 !important;
`;
